import { render, staticRenderFns } from "./CheckboxConfig.vue?vue&type=template&id=79cc5d87&scoped=true"
import script from "./CheckboxConfig.vue?vue&type=script&lang=js"
export * from "./CheckboxConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc5d87",
  null
  
)

export default component.exports